import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getName } from "country-list";
import { setLspOnboarding, getLspDetails, LspUpdatation } from "./lspSlice";
import {
  fetchAddress,
  fetchCities,
  fetchStates,
} from "../../../components/entities/address/addressesSlice";

function validEmail(email) {
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
    email || "",
  );
  return isValidEmail;
}
function validPhone(x) {
  const out = /^[0-9]+$/.test(x || "");
  return out;
}

const useLspUpdating = (id, initial) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLogin = location.pathname.includes("login");
  const { email } = useSelector((state) => state.login);

  const activeTab = location.pathname.split("/")[3] || "info";
  const { lspdetails, updatesmsg, status, isEdit, generaldata } = useSelector(
    (state) => state.lsponboarding,
  );
  const [lspdata, setLspdata] = useState();
  const [geninfo, setGeninfo] = useState();
  const [isSaveBtn, setIsSaveBtn] = useState(false);
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [countryServices, setCountryServices] = useState([]);

  const [entitypage, setEntitypage] = useState(0);
  const [entitypagelimit, setEntityPageLimit] = useState(10);

  const [servicepage, setServicePage] = useState(0);
  const [servicelimit, setServiceLimit] = useState(10);

  const onEnityPageChange = (event) => {
    setEntitypage(event.first);
    setEntityPageLimit(event.rows);
  };
  const onServiceChange = (event) => {
    setServicePage(event.first);
    setServiceLimit(event.rows);
  };

  useEffect(() => {
    dispatch(setLspOnboarding({ key: "updatesmsg", value: "" }));
    dispatch(setLspOnboarding({ key: "isEdit", value: false }));
    setIsUpdating(false);
  }, []);

  useEffect(() => {
    if (initial) {
      initialLoads(id);
    }
  }, [id]);

  const initialLoads = (id) => {
    dispatch(getLspDetails(id));

    dispatch(fetchAddress(id)).then((response) => {
      let dat =
        response?.payload?.data.length > 0 ? response?.payload?.data[0] : {};
      let country = { name: getName(dat.country), code: dat.country };
      dat = { ...dat, country: country };
      dispatch(fetchStates(dat.country.code)).then((sts) => {
        const options = sts.payload.map((state) => ({
          name: state.label,
          code: state.value,
        }));
        const currentstate = options.find((x) => x.code === dat.state);
        dat = { ...dat, state: currentstate };
        dispatch(fetchCities([dat.country.code, dat?.state?.code])).then(
          (response) => {
            const cityOptions = response.payload.map((city) => ({
              name: city.label,
              code: city.value,
            }));
            const currentcity = cityOptions.find((x) => x.code === dat.city);
            dat = { ...dat, city: currentcity };
            dispatch(setLspOnboarding({ key: "currentaddress", value: dat }));
          },
        );
      });
    });
  };

  // useEffect(() => {
  //   if (status === "updatelspsucces") {
  //     dispatch(getLspDetails(id));
  //   }
  // }, [status]);

  const handleEnableEdit = () => {
    setIsUpdating(false);
    dispatch(
      setLspOnboarding({
        key: "isEdit",
        value: true,
      }),
    );
  };

  const initialdata = () => {
    let obj = {
      id: lspdetails?.id,
      trading_name: lspdetails?.name,
      start_date: lspdetails?.start_date,
      end_date: lspdetails?.end_date,
      phone: lspdetails?.phone,
      phone_code: lspdetails?.phone_code,
      email: lspdetails?.email,
      hsp_manager_name: lspdetails?.hsp_manager_name,
      hsp_manager_email: lspdetails?.hsp_manager_email,
      account_manager_name: lspdetails?.account_manager_name,
      account_manager_email: lspdetails?.account_manager_email,
      account_manager_phone_code: lspdetails?.account_manager_phone_code,
      account_manager_phone: lspdetails?.account_manager_phone,
    };
    return obj;
  };

  useEffect(() => {
    setLspdata(lspdetails);
    const obj = initialdata();
    setGeninfo(obj);
    dispatch(
      setLspOnboarding({
        key: "generaldata",
        value: obj,
      }),
    );
    const accessarray = lspdetails?.access || [];
    let uniqueCountry = getCountryAcess(accessarray);
    setCountryServices(uniqueCountry);
  }, [lspdetails]);

  const getCountryAcess = (list) => {
    const output = list.map((d) => {
      const countryname = d?.entity?.country;
      let allservice = d?.services || [];
      const issamecountry = list.find(
        (x) =>
          x?.entity?.country === countryname && x?.entity?.id !== d.entity_id,
      );
      if (issamecountry) {
        allservice = [...allservice, ...(issamecountry?.services || [])];
      }
      const uniqueServices = allservice.filter(
        (service, index, self) =>
          index === self.findIndex((s) => s.id === service.id),
      );
      return {
        country: countryname,
        services: uniqueServices,
      };
    });
    const uniqueCountry = output.filter(
      (service, index, self) =>
        index === self.findIndex((s) => s.country === service.country),
    );
    return uniqueCountry;
  };
  const handleDiscardEdit = () => {
    const obj = initialdata();
    dispatch(
      setLspOnboarding({
        key: "isEdit",
        value: false,
      }),
    );
    setGeninfo(obj);
    dispatch(
      setLspOnboarding({
        key: "generaldata",
        value: obj,
      }),
    );
  };

  useEffect(() => {
    const areObjectsEqual = (obj1 = {}, obj2 = {}) => {
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }
      return Object.keys(obj1).every((key) => obj1[key] === obj2[key]);
    };
    const isIdentical = areObjectsEqual(geninfo, generaldata);

    const isTradeGeninfoValid =
      geninfo?.trading_name &&
      geninfo?.start_date &&
      geninfo?.phone &&
      geninfo?.phone_code &&
      validPhone(geninfo?.phone) &&
      validPhone(geninfo?.phone_code) &&
      geninfo?.email &&
      validEmail(geninfo?.email) &&
      geninfo?.hsp_manager_name &&
      geninfo?.hsp_manager_email &&
      validEmail(geninfo?.hsp_manager_email) &&
      geninfo?.account_manager_name &&
      geninfo?.account_manager_email &&
      validEmail(geninfo?.account_manager_email) &&
      geninfo?.account_manager_phone_code &&
      geninfo?.account_manager_phone &&
      validPhone(geninfo?.account_manager_phone_code) &&
      validPhone(geninfo?.account_manager_phone);

    setIsSaveBtn(isIdentical || !isTradeGeninfoValid);
  }, [generaldata, geninfo]);

  const handleGenEditChange = (name, value) => {
    setGeninfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdateLspGen = () => {
    let data = {
      ...geninfo,
      start_date: geninfo?.start_date?.toString(),
      end_date: geninfo?.end_date?.toString(),
    };
    setIsUpdating(true);
    dispatch(LspUpdatation(data)).then(() => {
      dispatch(
        setLspOnboarding({
          key: "updatesmsg",
          value: "General Information has been Updated.",
        }),
      );
      dispatch(setLspOnboarding({ key: "isEdit", value: false }));
      dispatch(setLspOnboarding({ key: "isisSaveBtn", value: true }));
      setIsUpdating(false);
      dispatch(getLspDetails(id));
    });
  };
  const updateMsgState = () => {
    dispatch(setLspOnboarding({ key: "updatesmsg", value: "" }));
  };
  return {
    lspdata,
    genstate: {
      status,
      activeTab,
      isEdit,
      geninfo,
      isSaveBtn,
      updatesmsg,
      isUpdating,
      isAuditSidebarVisible,
      countryServices,
      entitypagelimit,
      entitypage,
      servicepage,
      servicelimit,
    },
    handleEnableEdit,
    handleDiscardEdit,
    handleGenEditChange,
    handleUpdateLspGen,
    updateMsgState,
    initialLoads,
    setAuditSidebarVisible,
    onEnityPageChange,
    onServiceChange,
    isLogin,
    email,
  };
};

export default useLspUpdating;
